
// import { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import {
//     BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,
//     PieChart, Pie, Cell, CartesianGrid,
//     RadialBarChart, RadialBar, PolarAngleAxis,
//     RadarChart, Radar, PolarGrid, PolarAngleAxis as RadarAngle, PolarRadiusAxis,
//     ComposedChart, Line,
// } from "recharts";
// import "./dashboardcss/invoiceDashboard.css";
// import { BASE_URL } from "../../config/axios";

// /* ───────── constants & helpers ───────── */
// const CATS = {
//     employee: "Employee", transportation: "Transportation", duty_travel: "Duty travel",
//     office_rent: "Office rent", office_supplies: "Office supplies",
//     office_furniture_equipment: "Furniture & equipment", reports_documents: "Reports & documents",
//     road_survey: "Road survey",
// };
// const SHORT = {
//     employee: "Employee", transportation: "Transport", duty_travel: "Duty travel",
//     office_rent: "Rent", office_supplies: "Supplies", office_furniture_equipment: "Furniture",
//     reports_documents: "Reports", road_survey: "Survey",
// };
// const COLOR = {
//     employee: "#0F766E", transportation: "#2F5D9E", duty_travel: "#7C5CBF", office_rent: "#D98E04",
//     office_supplies: "#C2553F", office_furniture_equipment: "#3F8F5B", reports_documents: "#4A7FA7", road_survey: "#8795A9",
// };
// const C_RAISED = "#0F766E";
// const C_CLAIMED = "#2F5D9E";
// const FIELDS = ["current", "previous", "cumulative", "remaining", "eot_total_amount", "contract_amount"];
// const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// const FONT = "Inter, system-ui, sans-serif";
// const TICK = { fontSize: 11, fill: "#6B7A90", fontFamily: FONT };
// const ANIM = { animationDuration: 900, animationEasing: "ease-out" };

// /* labels: Invoice raised vs Claims */
// const TXT = {
//     raised: {
//         eyebrow: "Total raised · cumulative", vs: "current vs previous invoice", cnt: "Invoices",
//         of: "of contract billed", billed: "Billed", noPrev: "No previous invoice",
//         none: "No invoices raised yet.", nothing: "Nothing raised yet.", note: "Amount raised by category",
//         progress: "Billing progress by category", noData: "No billing data yet.", cvb: "Contract vs billed",
//         noProj: "No project billing yet.", tbl: "contract & billing", noInv: "Show projects with no invoices",
//         csv: "projects.csv",
//     },
//     claimed: {
//         eyebrow: "Total claimed · cumulative", vs: "current vs previous claim", cnt: "Claims",
//         of: "of contract claimed", billed: "Claimed", noPrev: "No previous claim",
//         none: "No claims raised yet.", nothing: "Nothing claimed yet.", note: "Amount claimed by category",
//         progress: "Claim progress by category", noData: "No claim data yet.", cvb: "Contract vs claimed",
//         noProj: "No project claims yet.", tbl: "contract & claims", noInv: "Show projects with no claims",
//         csv: "claim-projects.csv",
//     },
// };

// const CatTick = ({ x, y, payload }) => (
//     <text x={x} y={y} textAnchor="middle" fill="#6B7A90" fontSize={11} fontFamily={FONT}>
//         {String(payload.value).split(" ").map((w, i) => (
//             <tspan key={i} x={x} dy={i ? 13 : 14}>{w}</tspan>
//         ))}
//     </text>
// );

// const n = (v) => +v || 0;
// const inr = (v) => "₹" + Math.round(n(v)).toLocaleString("en-IN");
// const short = (v) => {
//     v = n(v);
//     return v >= 1e7 ? `₹${(v / 1e7).toFixed(2)} Cr` : v >= 1e5 ? `₹${(v / 1e5).toFixed(2)} L` : inr(v);
// };
// const pct = (v) => `${n(v).toFixed(1)}%`;
// const usedPct = (c) => (n(c.cumulative) + n(c.remaining) ? (n(c.cumulative) / (n(c.cumulative) + n(c.remaining))) * 100 : 0);
// const ratio = (a, b) => (n(b) ? (n(a) / n(b)) * 100 : 0);
// const pName = (p) => p.project_name || "Untitled project";
// const pLabel = (p) => `${pName(p)}${p.location ? ` – ${p.location}` : ""} (${String(p.project_id).slice(0, 4)})`;
// const trunc = (s, l = 18) => (s.length > l ? s.slice(0, l - 1) + "…" : s);
// const initials = (s) => s.split(/\s+|&/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

// const sumCats = (projects) => Object.entries(CATS).map(([key, name]) => {
//     const o = { key, name };
//     FIELDS.forEach((f) => { o[f] = projects.reduce((a, p) => a + n(p.categories?.[key]?.[f]), 0); });
//     return o;
// });

// /* ───────── hooks ───────── */
// function useCountUp(target, dur = 900) {
//     const [v, setV] = useState(0);
//     const last = useRef(0);
//     useEffect(() => {
//         const from = last.current, to = n(target), t0 = performance.now();
//         let raf;
//         const step = (t) => {
//             const p = Math.min((t - t0) / dur, 1);
//             const val = from + (to - from) * (1 - Math.pow(1 - p, 3));
//             last.current = val;
//             setV(val);
//             if (p < 1) raf = requestAnimationFrame(step);
//         };
//         raf = requestAnimationFrame(step);
//         return () => cancelAnimationFrame(raf);
//     }, [target, dur]);
//     return v;
// }

// function useInvoiceDashboard(http, baseUrl, f, enabled = true) {
//     const [st, setSt] = useState({ data: null, loading: true, error: null });
//     const [tick, setTick] = useState(0);
//     useEffect(() => {
//         if (!enabled) return;
//         let alive = true;
//         setSt((s) => ({ ...s, loading: true, error: null }));
//         http.get(`${baseUrl}/${f.project || "null"}/${f.month || "null"}/${f.year || "null"}/`)
//             .then((r) => {
//                 if (!alive) return;
//                 if (r.data?.success === false) throw new Error(r.data?.message || "API returned success: false");
//                 setSt({ data: r.data, loading: false, error: null });
//             })
//             .catch((e) => alive && setSt({ data: null, loading: false, error: e?.response?.data?.message || e.message || "Request failed" }));
//         return () => { alive = false; };
//     }, [http, baseUrl, f.project, f.month, f.year, tick, enabled]);
//     return { ...st, reload: () => setTick((t) => t + 1) };
// }

// /* ───────── small pieces ───────── */
// const Panel = ({ title, note, children, i = 0, className = "" }) => (
//     <section className={`invd-panel ${className}`} style={{ "--i": i }}>
//         <div className="invd-ph"><h3>{title}</h3>{note && <span>{note}</span>}</div>
//         {children}
//     </section>
// );

// const Stat = ({ label, value, sub, tone, i = 0, raw }) => {
//     const v = useCountUp(value);
//     return (
//         <div className="invd-stat" style={{ "--i": i }}>
//             <p>{label}</p>
//             <strong>{raw ? Math.round(v) : short(v)}</strong>
//             {sub && <span className={tone || ""}>{sub}</span>}
//         </div>
//     );
// };

// const Select = ({ value, onChange, children }) => (
//     <select className="invd-select" value={value} onChange={(e) => onChange(e.target.value)}>{children}</select>
// );

// const Tip = ({ active, payload, label, fmt = inr }) => {
//     const items = (payload || []).filter((p) => n(p.value));
//     return active && items.length ? (
//         <div className="invd-tip">
//             <p className="h">{items[0].payload?.name ?? label}</p>
//             {items.map((p) => (
//                 <p key={p.dataKey || p.name}>
//                     <span><i className="invd-dot" style={{ background: p.color || p.payload?.fill }} />{p.name}</span>
//                     <b>{fmt(p.value)}</b>
//                 </p>
//             ))}
//         </div>
//     ) : null;
// };

// const Meter = ({ pct: p, color }) => (
//     <div className="invd-meter"><i style={{ width: `${Math.min(p, 100)}%`, background: color }} /></div>
// );

// const status = (p) => (p >= 90 ? ["Near limit", "bad"] : p >= 50 ? ["On track", "mid"] : p > 0 ? ["Started", "ok"] : ["Not started", "off"]);
// const Pill = ({ p }) => { const [t, k] = status(p); return <em className={`invd-pill ${k}`}>{t}</em>; };

// const Ring = ({ value }) => {
//     const r = 48, c = 2 * Math.PI * r, v = Math.min(n(value), 100);
//     return (
//         <svg className="invd-ring" width="132" height="132" viewBox="0 0 120 120" style={{ "--c": c, "--o": c - (c * v) / 100 }}>
//             <circle cx="60" cy="60" r={r} className="trk" />
//             <circle cx="60" cy="60" r={r} className="val" strokeDasharray={c} />
//             <text x="60" y="67" textAnchor="middle">{v.toFixed(1)}%</text>
//         </svg>
//     );
// };

// const Hero = ({ s, utilAll, delta, hasPrev, activeCount, invoices, T }) => {
//     const v = useCountUp(s.cumulative);
//     return (
//         <div className="invd-hero">
//             <div className="invd-hero-l">
//                 <span className="invd-eyebrow">{T.eyebrow}</span>
//                 <h2>{short(v)}</h2>
//                 <div className="invd-hero-meta">
//                     <span className={`invd-delta ${delta >= 0 ? "up" : "down"}`}>
//                         {hasPrev ? `${delta >= 0 ? "▲" : "▼"} ${Math.abs(delta).toFixed(1)}%` : "New"}
//                     </span>
//                     <span>{T.vs}</span>
//                 </div>
//                 <div className="invd-hero-chips">
//                     <div><small>Remaining</small><b>{short(s.remaining)}</b></div>
//                     <div><small>Active projects</small><b>{activeCount} / {n(s.total_projects)}</b></div>
//                     <div><small>{T.cnt}</small><b>{invoices}</b></div>
//                 </div>
//             </div>
//             <div className="invd-hero-r"><Ring value={utilAll} /><span>{T.of}</span></div>
//         </div>
//     );
// };

// const exportCsv = (rows, T) => {
//     const head = ["Project", "Location", T.cnt, "Current", "Previous", "Cumulative", "Remaining"];
//     const body = rows.map((p) => [pName(p), p.location || "", (p.invoice_ids || []).length,
//     n(p.totals?.current), n(p.totals?.previous), n(p.totals?.cumulative), n(p.totals?.remaining)]);
//     const csv = [head, ...body].map((r) => r.map((x) => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
//     a.download = T.csv;
//     a.click();
// };

// const exportBothCsv = (rows) => {
//     const head = ["Project", "Location", "Invoices", "Claims", "Raised", "Claimed", "Unclaimed", "Claimed %"];
//     const body = rows.map((r) => [r.name, r.location, r.rInv, r.cInv, r.rCum, r.cCum, r.gap, r.pct.toFixed(2)]);
//     const csv = [head, ...body].map((r) => r.map((x) => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
//     a.download = "raised-vs-claimed.csv";
//     a.click();
// };

// const Skeleton = () => (
//     <div className="invd-stack">
//         <div className="invd-skel h130" />
//         <div className="invd-stats">{[...Array(3)].map((_, i) => <div key={i} className="invd-skel h90" />)}</div>
//         <div className="invd-cards">{[...Array(8)].map((_, i) => <div key={i} className="invd-skel h130" />)}</div>
//         <div className="invd-grid"><div className="invd-skel h320" /><div className="invd-skel h320" /></div>
//     </div>
// );

// /* ───────── main view (raised / claimed) ───────── */
// function RaisedView({ data, onPickProject, activeProject, T = TXT.raised, showCP = true }) {
//     const [cat, setCat] = useState("all");
//     const [showEmpty, setShowEmpty] = useState(false);
//     const [q, setQ] = useState("");
//     const [hover, setHover] = useState(null);
//     const s = data.summary || {};
//     const projects = data.projects || [];

//     const active = useMemo(() => projects.filter((p) => n(p.totals?.cumulative) || (p.invoice_ids || []).length), [projects]);
//     const cats = useMemo(() => sumCats(projects), [projects]);
//     const cur = n(s.current), prev = n(s.previous);
//     const delta = prev ? ((cur - prev) / prev) * 100 : 0;
//     const utilAll = usedPct({ cumulative: s.cumulative, remaining: s.remaining });
//     const invoiceCount = projects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
//     const contractEot = cats.reduce((a, c) => a + c.eot_total_amount, 0);

//     const compare = cats.map((c) => ({ name: c.name, label: SHORT[c.key], Previous: c.previous, Current: c.current }));
//     const share = cats.filter((c) => c.current > 0).map((c) => ({ name: c.name, value: c.current, key: c.key }));
//     const shareTotal = share.reduce((a, d) => a + d.value, 0);

//     const stacked = cats.filter((c) => c.cumulative || c.remaining).map((c) => ({ name: c.name, Cumulative: c.cumulative, Remaining: c.remaining }));
//     const contract = cats.filter((c) => c.eot_total_amount || c.contract_amount)
//         .map((c) => ({ name: c.name, label: SHORT[c.key], "Contract (EOT)": c.eot_total_amount, "Contract amount": c.contract_amount, Cumulative: c.cumulative }));
//     const radar = cats.map((c) => ({ name: c.name, Used: +usedPct(c).toFixed(2) }));
//     const hasRadar = radar.some((r) => r.Used > 0);
//     const topProjects = projects.filter((p) => n(p.totals?.cumulative) || n(p.totals?.remaining))
//         .sort((a, b) => n(b.totals?.cumulative) - n(a.totals?.cumulative)).slice(0, 8)
//         .map((p) => ({ id: p.project_id, name: trunc(pName(p)), Cumulative: n(p.totals?.cumulative), Remaining: n(p.totals?.remaining) }));

//     const tableCats = cat === "all" ? cats : cats.filter((c) => c.key === cat);
//     const tableProjects = (showEmpty ? projects : active)
//         .filter((p) => `${pName(p)} ${p.location || ""}`.toLowerCase().includes(q.trim().toLowerCase()))
//         .slice().sort((a, b) => n(b.totals?.cumulative) - n(a.totals?.cumulative));
//     const hv = hover != null ? share[hover] : null;

//     return (
//         <div className="invd-stack">
//             <Hero s={s} utilAll={utilAll} delta={delta} hasPrev={!!prev} activeCount={active.length} invoices={invoiceCount} T={T} />

//             <div className="invd-stats">
//                 {showCP && (
//                     <>
//                         <Stat i={0} label="Current" value={cur}
//                             sub={prev ? `${delta >= 0 ? "▲" : "▼"} ${Math.abs(delta).toFixed(1)}% vs previous` : T.noPrev}
//                             tone={delta >= 0 ? "up" : "down"} />
//                         <Stat i={1} label="Previous" value={prev} sub={inr(prev)} />
//                     </>
//                 )}
//                 <Stat i={2} label="Contract (EOT)" value={contractEot} sub="Total extension-of-time amount" />
//             </div>

//             <div className="invd-cards">
//                 {cats.map((c, i) => (
//                     <button type="button" key={c.key} style={{ "--c": COLOR[c.key], "--i": i }}
//                         className={`invd-card ${cat === c.key ? "on" : ""} ${c.cumulative ? "" : "zero"}`}
//                         onClick={() => setCat((x) => (x === c.key ? "all" : c.key))}>
//                         <div className="invd-card-top">
//                             <span className="invd-mono">{initials(c.name)}</span>
//                             <h4>{c.name}</h4>
//                             <Pill p={usedPct(c)} />
//                         </div>
//                         <strong>{short(c.current)}</strong>
//                         <span className="invd-card-sub">current · previous {short(c.previous)}</span>
//                         <Meter pct={usedPct(c)} color={COLOR[c.key]} />
//                         <div className="invd-card-foot">
//                             <span>{usedPct(c).toFixed(2)}% used</span>
//                             <span>Remaining {short(c.remaining)}</span>
//                         </div>
//                     </button>
//                 ))}
//             </div>

//             {/* row 1 */}
//             <div className="invd-grid">
//                 <Panel i={0} title="Current vs previous" note={T.note}>
//                     {compare.length ? (
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={compare} margin={{ left: 4, right: 8, top: 8 }}>
//                                     <defs>
//                                         <linearGradient id="gCur" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#14B8A6" /><stop offset="100%" stopColor="#0F766E" />
//                                         </linearGradient>
//                                         <linearGradient id="gPrev" x1="0" y1="0" x2="0" y2="1">
//                                             <stop offset="0%" stopColor="#B4C1D2" /><stop offset="100%" stopColor="#8FA0B5" />
//                                         </linearGradient>
//                                     </defs>
//                                     <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                     <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
//                                     <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
//                                     <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Bar dataKey="Previous" fill="url(#gPrev)" radius={[6, 6, 0, 0]} maxBarSize={30} {...ANIM} />
//                                     <Bar dataKey="Current" fill="url(#gCur)" radius={[6, 6, 0, 0]} maxBarSize={30} {...ANIM} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : <div className="invd-empty">{T.none}</div>}
//                 </Panel>

//                 <Panel i={1} title="Share of current amount" note="Hover a slice">
//                     {share.length ? (
//                         <>
//                             <div className="invd-donut">
//                                 <ResponsiveContainer width="100%" height="100%">
//                                     <PieChart>
//                                         <Pie data={share} dataKey="value" innerRadius={62} outerRadius={90} paddingAngle={3} cornerRadius={5}
//                                             stroke="none" onMouseEnter={(_, i) => setHover(i)} onMouseLeave={() => setHover(null)} {...ANIM}>
//                                             {share.map((d, i) => (
//                                                 <Cell key={d.key} fill={COLOR[d.key]}
//                                                     style={{ transition: "opacity .2s", opacity: hover == null || hover === i ? 1 : 0.35, outline: "none" }} />
//                                             ))}
//                                         </Pie>
//                                     </PieChart>
//                                 </ResponsiveContainer>
//                                 <div className="invd-donut-c" key={hv ? hv.key : "all"}>
//                                     <span>{hv ? hv.name : "Total"}</span>
//                                     <b>{short(hv ? hv.value : shareTotal)}</b>
//                                     {hv && <em>{((hv.value / shareTotal) * 100).toFixed(1)}%</em>}
//                                 </div>
//                             </div>
//                             <ul className="invd-legend">
//                                 {share.map((d, i) => (
//                                     <li key={d.key} className={hover === i ? "hl" : ""} onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)}>
//                                         <span><i style={{ background: COLOR[d.key] }} />{d.name}</span>
//                                         <b>{((d.value / shareTotal) * 100).toFixed(1)}%</b>
//                                     </li>
//                                 ))}
//                             </ul>
//                         </>
//                     ) : <div className="invd-empty">{T.nothing}</div>}
//                 </Panel>
//             </div>

//             {/* row 2 */}
//             <div className="invd-grid">
//                 <Panel i={2} title={T.progress} note="Cumulative vs remaining">
//                     {stacked.length ? (
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={stacked} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
//                                     <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                     <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
//                                     <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={120} />
//                                     <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Bar dataKey="Cumulative" stackId="a" fill="#0F766E" maxBarSize={20} {...ANIM} />
//                                     <Bar dataKey="Remaining" stackId="a" fill="#D5DEE9" radius={[0, 6, 6, 0]} maxBarSize={20} {...ANIM} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : <div className="invd-empty">{T.noData}</div>}
//                 </Panel>

//                 <Panel i={3} title="Overall utilization" note="Cumulative ÷ (cumulative + remaining)">
//                     <div className="invd-donut gauge">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <RadialBarChart innerRadius="72%" outerRadius="100%" data={[{ name: "Used", value: Math.min(utilAll, 100), fill: "#0F766E" }]}
//                                 startAngle={210} endAngle={-30}>
//                                 <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
//                                 <RadialBar dataKey="value" cornerRadius={12} background={{ fill: "#EDF1F5" }} {...ANIM} />
//                             </RadialBarChart>
//                         </ResponsiveContainer>
//                         <div className="invd-donut-c"><b className="big">{utilAll.toFixed(1)}%</b><span>{T.of}</span></div>
//                     </div>
//                     <div className="invd-minis">
//                         <div><span>{T.billed}</span><b>{short(s.cumulative)}</b></div>
//                         <div><span>Left</span><b>{short(s.remaining)}</b></div>
//                     </div>
//                 </Panel>
//             </div>

//             {/* row 3 */}
//             <div className="invd-grid even">
//                 <Panel i={4} title={T.cvb} note="EOT, BOQ and cumulative">
//                     {contract.length ? (
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <ComposedChart data={contract} margin={{ left: 4, right: 8, top: 8 }}>
//                                     <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                     <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
//                                     <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
//                                     <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Bar dataKey="Contract (EOT)" fill="#2F5D9E" radius={[6, 6, 0, 0]} maxBarSize={22} {...ANIM} />
//                                     <Bar dataKey="Contract amount" fill="#D98E04" radius={[6, 6, 0, 0]} maxBarSize={22} {...ANIM} />
//                                     <Line type="monotone" dataKey="Cumulative" stroke="#0F766E" strokeWidth={2.5}
//                                         dot={{ r: 4, fill: "#fff", strokeWidth: 2 }} activeDot={{ r: 6 }} {...ANIM} />
//                                 </ComposedChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : <div className="invd-empty">No contract data.</div>}
//                 </Panel>

//                 <Panel i={5} title="Utilization radar" note="% used per category">
//                     {hasRadar ? (
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <RadarChart data={radar} outerRadius="72%">
//                                     <PolarGrid stroke="#E3E9F0" />
//                                     <RadarAngle dataKey="name" tick={{ ...TICK, fontSize: 10.5 }} />
//                                     <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ ...TICK, fontSize: 9 }} axisLine={false} />
//                                     <Tooltip content={<Tip fmt={pct} />} />
//                                     <Radar name="Used" dataKey="Used" stroke="#0F766E" fill="#0F766E" fillOpacity={0.28} strokeWidth={2} {...ANIM} />
//                                 </RadarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : <div className="invd-empty">No utilization yet.</div>}
//                 </Panel>
//             </div>

//             {/* row 4 */}
//             <Panel i={6} title="Top projects" note="Click a bar to filter by project">
//                 {topProjects.length ? (
//                     <div className="invd-chart tall">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <BarChart data={topProjects} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
//                                 <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                 <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
//                                 <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={130} />
//                                 <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                 <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                 <Bar dataKey="Cumulative" stackId="p" fill="#2F5D9E" maxBarSize={18} cursor="pointer"
//                                     onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM}>
//                                     {topProjects.map((d) => <Cell key={d.id} fill={activeProject === d.id ? "#0F766E" : "#2F5D9E"} />)}
//                                 </Bar>
//                                 <Bar dataKey="Remaining" stackId="p" fill="#D5DEE9" radius={[0, 6, 6, 0]} maxBarSize={18} {...ANIM} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 ) : <div className="invd-empty">{T.noProj}</div>}
//             </Panel>

//             <Panel i={7} title={`${cat === "all" ? "All categories" : CATS[cat]}: ${T.tbl}`}>
//                 <div className="invd-tw">
//                     <table className="invd-table">
//                         <thead>
//                             <tr>
//                                 <th>Category</th><th className="r">Contract (EOT)</th><th className="r">BOQ rate</th>
//                                 <th className="r">Previous</th><th className="r">Current</th>
//                                 <th className="r">Cumulative</th><th className="r">Remaining</th><th>Used</th>
//                             </tr>
//                         </thead>
//                         <tbody key={cat}>
//                             {tableCats.map((c, i) => (
//                                 <tr key={c.key} style={{ "--i": i }}>
//                                     <td><span className="invd-dot" style={{ background: COLOR[c.key] }} /><b>{c.name}</b></td>
//                                     <td className="r">{inr(c.eot_total_amount)}</td>
//                                     <td className="r">{inr(c.contract_amount)}</td>
//                                     <td className="r">{inr(c.previous)}</td>
//                                     <td className="r amt">{inr(c.current)}</td>
//                                     <td className="r">{inr(c.cumulative)}</td>
//                                     <td className="r">{inr(c.remaining)}</td>
//                                     <td className="usedcell"><Meter pct={usedPct(c)} color={COLOR[c.key]} /><small>{usedPct(c).toFixed(2)}%</small></td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                         <tfoot>
//                             <tr>
//                                 <td>Total</td>
//                                 {["eot_total_amount", "contract_amount", "previous", "current", "cumulative", "remaining"].map((f) => (
//                                     <td key={f} className="r">{inr(tableCats.reduce((a, c) => a + c[f], 0))}</td>
//                                 ))}
//                                 <td />
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </div>
//             </Panel>

//             <Panel i={8} title="Projects" note={`${tableProjects.length} of ${projects.length} shown`}>
//                 <div className="invd-toolbar">
//                     <input className="invd-input" placeholder="Search project or location…" value={q} onChange={(e) => setQ(e.target.value)} />
//                     <label className="invd-check">
//                         <input type="checkbox" checked={showEmpty} onChange={(e) => setShowEmpty(e.target.checked)} />
//                         {T.noInv}
//                     </label>
//                     <button type="button" className="invd-btn" onClick={() => exportCsv(tableProjects, T)}>Export CSV</button>
//                 </div>
//                 <div className="invd-tw">
//                     <table className="invd-table">
//                         <thead>
//                             <tr>
//                                 <th>Project</th><th>Location</th><th className="r">{T.cnt}</th><th>Months</th>
//                                 <th className="r">Current</th><th className="r">Previous</th>
//                                 <th className="r">Cumulative</th><th className="r">Remaining</th>
//                             </tr>
//                         </thead>
//                         <tbody key={`${showEmpty}|${q}`}>
//                             {tableProjects.map((p, i) => (
//                                 <tr key={p.project_id} style={{ "--i": Math.min(i, 20), cursor: "pointer" }}
//                                     className={`${n(p.totals?.cumulative) ? "" : "dim"} ${activeProject === p.project_id ? "sel" : ""}`}
//                                     onClick={() => onPickProject(activeProject === p.project_id ? "" : p.project_id)}>
//                                     <td><b>{pName(p)}</b></td>
//                                     <td>{p.location || "—"}</td>
//                                     <td className="r">{(p.invoice_ids || []).length}</td>
//                                     <td>{(p.months_available || []).map((m) => MONTHS[+m - 1]).join(", ")} {(p.years_available || []).join(", ")}</td>
//                                     <td className="r amt">{inr(p.totals?.current)}</td>
//                                     <td className="r">{inr(p.totals?.previous)}</td>
//                                     <td className="r">{inr(p.totals?.cumulative)}</td>
//                                     <td className="r">{inr(p.totals?.remaining)}</td>
//                                 </tr>
//                             ))}
//                             {!tableProjects.length && <tr><td colSpan={8}><div className="invd-empty">No projects to show.</div></td></tr>}
//                         </tbody>
//                     </table>
//                 </div>
//             </Panel>
//         </div>
//     );
// }

// /* ───────── combined view (raised + claimed) ───────── */
// function CombinedView({ raised, claimed, onPickProject, activeProject, showCP = true }) {
//     const [cat, setCat] = useState("all");
//     const [showEmpty, setShowEmpty] = useState(false);
//     const [q, setQ] = useState("");

//     const rs = raised.summary || {}, cs = claimed.summary || {};
//     const rProjects = raised.projects || [], cProjects = claimed.projects || [];

//     const rCats = useMemo(() => sumCats(rProjects), [rProjects]);
//     const cCats = useMemo(() => sumCats(cProjects), [cProjects]);
//     const cats = useMemo(() => rCats.map((r, i) => {
//         const c = cCats[i] || {};
//         return {
//             key: r.key, name: r.name,
//             rCum: r.cumulative, cCum: n(c.cumulative),
//             rCur: r.current, cCur: n(c.current),
//             rPrev: r.previous, cPrev: n(c.previous),
//             rRem: r.remaining, cRem: n(c.remaining),
//             rUsed: usedPct(r), cUsed: usedPct(c),
//             eot: r.eot_total_amount, boq: r.contract_amount,
//             gap: r.cumulative - n(c.cumulative),
//             pct: ratio(c.cumulative, r.cumulative),
//         };
//     }), [rCats, cCats]);

//     const rows = useMemo(() => {
//         const map = new Map();
//         rProjects.forEach((p) => map.set(p.project_id, { id: p.project_id, name: pName(p), location: p.location || "", rInv: (p.invoice_ids || []).length, cInv: 0, rCum: n(p.totals?.cumulative), cCum: 0 }));
//         cProjects.forEach((p) => {
//             const o = map.get(p.project_id) || { id: p.project_id, name: pName(p), location: p.location || "", rInv: 0, rCum: 0 };
//             o.cInv = (p.invoice_ids || []).length;
//             o.cCum = n(p.totals?.cumulative);
//             map.set(p.project_id, o);
//         });
//         return [...map.values()].map((r) => ({ ...r, gap: r.rCum - r.cCum, pct: ratio(r.cCum, r.rCum) }));
//     }, [rProjects, cProjects]);

//     const rCum = n(rs.cumulative), cCum = n(cs.cumulative), gap = rCum - cCum;
//     const claimPct = ratio(cCum, rCum);
//     const rInv = rProjects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
//     const cInv = cProjects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
//     const activeCount = rows.filter((r) => r.rCum || r.cCum).length;
//     const eotTotal = cats.reduce((a, c) => a + c.eot, 0);

//     const v = useCountUp(rCum);

//     const byCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], Raised: c.rCum, Claimed: c.cCum }));
//     const curCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], "Raised (current)": c.rCur, "Claimed (current)": c.cCur }));
//     const remCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], "Raised (remaining)": c.rRem, "Claimed (remaining)": c.cRem }));
//     const radar = cats.map((c) => ({ name: c.name, Raised: +c.rUsed.toFixed(2), Claimed: +c.cUsed.toFixed(2) }));
//     const hasRadar = radar.some((r) => r.Raised > 0 || r.Claimed > 0);
//     const topProjects = rows.filter((r) => r.rCum || r.cCum).sort((a, b) => b.rCum - a.rCum).slice(0, 8)
//         .map((r) => ({ id: r.id, name: trunc(r.name), Raised: r.rCum, Claimed: r.cCum }));

//     const tableCats = cat === "all" ? cats : cats.filter((c) => c.key === cat);
//     const tableRows = (showEmpty ? rows : rows.filter((r) => r.rCum || r.cCum || r.rInv || r.cInv))
//         .filter((r) => `${r.name} ${r.location}`.toLowerCase().includes(q.trim().toLowerCase()))
//         .slice().sort((a, b) => b.rCum - a.rCum);

//     return (
//         <div className="invd-stack">
//             {/* hero */}
//             <div className="invd-hero">
//                 <div className="invd-hero-l">
//                     <span className="invd-eyebrow">Total raised · cumulative</span>
//                     <h2>{short(v)}</h2>
//                     <div className="invd-hero-meta">
//                         <span className={`invd-delta ${gap > 0 ? "down" : "up"}`}>{short(Math.abs(gap))} {gap >= 0 ? "unclaimed" : "over-claimed"}</span>
//                         <span>raised minus claimed</span>
//                     </div>
//                     <div className="invd-hero-chips">
//                         <div><small>Claimed</small><b>{short(cCum)}</b></div>
//                         <div><small>Active projects</small><b>{activeCount} / {n(rs.total_projects)}</b></div>
//                         <div><small>Invoices</small><b>{rInv}</b></div>
//                         <div><small>Claims</small><b>{cInv}</b></div>
//                     </div>
//                 </div>
//                 <div className="invd-hero-r"><Ring value={claimPct} /><span>of raised amount claimed</span></div>
//             </div>

//             {/* stats */}
//             <div className="invd-stats">
//                 <Stat i={0} label="Raised (cumulative)" value={rCum} sub={`Remaining ${short(rs.remaining)}`} />
//                 <Stat i={1} label="Claimed (cumulative)" value={cCum} sub={`Remaining ${short(cs.remaining)}`} />
//                 <Stat i={2} label={gap >= 0 ? "Unclaimed" : "Over-claimed"} value={Math.abs(gap)} sub={`${claimPct.toFixed(1)}% claimed`} tone={gap > 0 ? "down" : "up"} />
//                 {showCP && <Stat i={3} label="Raised (current)" value={n(rs.current)} sub={`Previous ${short(rs.previous)}`} />}
//                 {showCP && <Stat i={4} label="Claimed (current)" value={n(cs.current)} sub={`Previous ${short(cs.previous)}`} />}
//                 <Stat i={5} label="Contract (EOT)" value={eotTotal} sub="Total extension-of-time amount" />
//             </div>

//             {/* category cards */}
//             <div className="invd-cards">
//                 {cats.map((c, i) => (
//                     <button type="button" key={c.key} style={{ "--c": COLOR[c.key], "--i": i }}
//                         className={`invd-card ${cat === c.key ? "on" : ""} ${c.rCum || c.cCum ? "" : "zero"}`}
//                         onClick={() => setCat((x) => (x === c.key ? "all" : c.key))}>
//                         <div className="invd-card-top">
//                             <span className="invd-mono">{initials(c.name)}</span>
//                             <h4>{c.name}</h4>
//                             <Pill p={c.pct} />
//                         </div>
//                         <strong>{short(c.rCum)}</strong>
//                         <span className="invd-card-sub">raised · claimed {short(c.cCum)}</span>
//                         <Meter pct={c.pct} color={COLOR[c.key]} />
//                         <div className="invd-card-foot">
//                             <span>{c.pct.toFixed(2)}% claimed</span>
//                             <span>{c.gap >= 0 ? "Unclaimed" : "Over"} {short(Math.abs(c.gap))}</span>
//                         </div>
//                     </button>
//                 ))}
//             </div>

//             {/* row 1 */}
//             <div className="invd-grid">
//                 <Panel i={0} title="Raised vs claimed" note="Cumulative by category">
//                     <div className="invd-chart">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <BarChart data={byCat} margin={{ left: 4, right: 8, top: 8 }}>
//                                 <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                 <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
//                                 <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
//                                 <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                 <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                 <Bar dataKey="Raised" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                                 <Bar dataKey="Claimed" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 </Panel>

//                 <Panel i={1} title="Claim coverage" note="Claimed ÷ raised">
//                     <div className="invd-donut gauge">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <RadialBarChart innerRadius="72%" outerRadius="100%" data={[{ name: "Claimed", value: Math.min(claimPct, 100), fill: C_CLAIMED }]}
//                                 startAngle={210} endAngle={-30}>
//                                 <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
//                                 <RadialBar dataKey="value" cornerRadius={12} background={{ fill: "#EDF1F5" }} {...ANIM} />
//                             </RadialBarChart>
//                         </ResponsiveContainer>
//                         <div className="invd-donut-c"><b className="big" style={{ color: C_CLAIMED }}>{claimPct.toFixed(1)}%</b><span>of raised claimed</span></div>
//                     </div>
//                     <div className="invd-minis">
//                         <div><span>Raised</span><b>{short(rCum)}</b></div>
//                         <div><span>Claimed</span><b>{short(cCum)}</b></div>
//                     </div>
//                 </Panel>
//             </div>

//             {/* row 2 */}
//             <div className="invd-grid even">
//                 {showCP ? (
//                     <Panel i={2} title="Current: raised vs claimed" note="Amount in selected period">
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={curCat} margin={{ left: 4, right: 8, top: 8 }}>
//                                     <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                     <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
//                                     <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
//                                     <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Bar dataKey="Raised (current)" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                                     <Bar dataKey="Claimed (current)" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     </Panel>
//                 ) : (
//                     <Panel i={2} title="Remaining: raised vs claimed" note="Balance left by category">
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={remCat} margin={{ left: 4, right: 8, top: 8 }}>
//                                     <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                     <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
//                                     <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
//                                     <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Bar dataKey="Raised (remaining)" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                                     <Bar dataKey="Claimed (remaining)" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     </Panel>
//                 )}

//                 <Panel i={3} title="Utilization radar" note="% used per category">
//                     {hasRadar ? (
//                         <div className="invd-chart">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <RadarChart data={radar} outerRadius="72%">
//                                     <PolarGrid stroke="#E3E9F0" />
//                                     <RadarAngle dataKey="name" tick={{ ...TICK, fontSize: 10.5 }} />
//                                     <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ ...TICK, fontSize: 9 }} axisLine={false} />
//                                     <Tooltip content={<Tip fmt={pct} />} />
//                                     <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                     <Radar name="Raised" dataKey="Raised" stroke={C_RAISED} fill={C_RAISED} fillOpacity={0.22} strokeWidth={2} {...ANIM} />
//                                     <Radar name="Claimed" dataKey="Claimed" stroke={C_CLAIMED} fill={C_CLAIMED} fillOpacity={0.22} strokeWidth={2} {...ANIM} />
//                                 </RadarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     ) : <div className="invd-empty">No utilization yet.</div>}
//                 </Panel>
//             </div>

//             {/* row 3 */}
//             <Panel i={4} title="Top projects" note="Raised vs claimed · click a bar to filter by project">
//                 {topProjects.length ? (
//                     <div className="invd-chart tall">
//                         <ResponsiveContainer width="100%" height="100%">
//                             <BarChart data={topProjects} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
//                                 <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
//                                 <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
//                                 <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={130} />
//                                 <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
//                                 <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
//                                 <Bar dataKey="Raised" fill={C_RAISED} radius={[0, 6, 6, 0]} maxBarSize={14} cursor="pointer"
//                                     onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM} />
//                                 <Bar dataKey="Claimed" fill={C_CLAIMED} radius={[0, 6, 6, 0]} maxBarSize={14} cursor="pointer"
//                                     onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM} />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>
//                 ) : <div className="invd-empty">No project data yet.</div>}
//             </Panel>

//             {/* category table */}
//             <Panel i={5} title={`${cat === "all" ? "All categories" : CATS[cat]}: raised vs claimed`}>
//                 <div className="invd-tw">
//                     <table className="invd-table">
//                         <thead>
//                             <tr>
//                                 <th>Category</th><th className="r">Contract (EOT)</th>
//                                 <th className="r">Raised</th><th className="r">Claimed</th>
//                                 <th className="r">Unclaimed</th><th className="r">Raised remaining</th>
//                                 <th className="r">Claimed remaining</th><th>Claimed %</th>
//                             </tr>
//                         </thead>
//                         <tbody key={cat}>
//                             {tableCats.map((c, i) => (
//                                 <tr key={c.key} style={{ "--i": i }}>
//                                     <td><span className="invd-dot" style={{ background: COLOR[c.key] }} /><b>{c.name}</b></td>
//                                     <td className="r">{inr(c.eot)}</td>
//                                     <td className="r amt">{inr(c.rCum)}</td>
//                                     <td className="r">{inr(c.cCum)}</td>
//                                     <td className="r">{inr(c.gap)}</td>
//                                     <td className="r">{inr(c.rRem)}</td>
//                                     <td className="r">{inr(c.cRem)}</td>
//                                     <td className="usedcell"><Meter pct={c.pct} color={COLOR[c.key]} /><small>{c.pct.toFixed(2)}%</small></td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                         <tfoot>
//                             <tr>
//                                 <td>Total</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.eot, 0))}</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.rCum, 0))}</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.cCum, 0))}</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.gap, 0))}</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.rRem, 0))}</td>
//                                 <td className="r">{inr(tableCats.reduce((a, c) => a + c.cRem, 0))}</td>
//                                 <td />
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </div>
//             </Panel>

//             {/* projects table */}
//             <Panel i={6} title="Projects" note={`${tableRows.length} of ${rows.length} shown`}>
//                 <div className="invd-toolbar">
//                     <input className="invd-input" placeholder="Search project or location…" value={q} onChange={(e) => setQ(e.target.value)} />
//                     <label className="invd-check">
//                         <input type="checkbox" checked={showEmpty} onChange={(e) => setShowEmpty(e.target.checked)} />
//                         Show projects with no invoices or claims
//                     </label>
//                     <button type="button" className="invd-btn" onClick={() => exportBothCsv(tableRows)}>Export CSV</button>
//                 </div>
//                 <div className="invd-tw">
//                     <table className="invd-table">
//                         <thead>
//                             <tr>
//                                 <th>Project</th><th>Location</th>
//                                 <th className="r">Invoices</th><th className="r">Claims</th>
//                                 <th className="r">Raised</th><th className="r">Claimed</th>
//                                 <th className="r">Unclaimed</th><th>Claimed %</th>
//                             </tr>
//                         </thead>
//                         <tbody key={`${showEmpty}|${q}`}>
//                             {tableRows.map((r, i) => (
//                                 <tr key={r.id} style={{ "--i": Math.min(i, 20), cursor: "pointer" }}
//                                     className={`${r.rCum || r.cCum ? "" : "dim"} ${activeProject === r.id ? "sel" : ""}`}
//                                     onClick={() => onPickProject(activeProject === r.id ? "" : r.id)}>
//                                     <td><b>{r.name}</b></td>
//                                     <td>{r.location || "—"}</td>
//                                     <td className="r">{r.rInv}</td>
//                                     <td className="r">{r.cInv}</td>
//                                     <td className="r amt">{inr(r.rCum)}</td>
//                                     <td className="r">{inr(r.cCum)}</td>
//                                     <td className="r">{inr(r.gap)}</td>
//                                     <td className="usedcell"><Meter pct={r.pct} color={C_CLAIMED} /><small>{r.pct.toFixed(2)}%</small></td>
//                                 </tr>
//                             ))}
//                             {!tableRows.length && <tr><td colSpan={8}><div className="invd-empty">No projects to show.</div></td></tr>}
//                         </tbody>
//                     </table>
//                 </div>
//             </Panel>
//         </div>
//     );
// }

// const Soon = ({ name }) => (
//     <div className="invd-soon"><b>{name} is not connected yet</b><span>Add its endpoint in useInvoiceDashboard and render a view here.</span></div>
// );

// /* ───────── page ───────── */
// export default function InvoiceDashboard({
//     baseUrl = `${BASE_URL}/siteproject/invoicedashboard`,
//     claimUrl = `${BASE_URL}/siteproject/invoiceclaimdashboard`,
//     http = axios,
// }) {
//     const [f, setF] = useState({ project: "", month: "", year: "" });
//     const [stage, setStage] = useState("raised");
//     const [opts, setOpts] = useState({ projects: [], months: [], years: [] });

//     const isBoth = stage === "both";
//     const raised = useInvoiceDashboard(http, baseUrl, f, stage === "raised" || isBoth);
//     const claimed = useInvoiceDashboard(http, claimUrl, f, stage === "claimed" || isBoth);

//     const single = stage === "claimed" ? claimed : raised;
//     const ready = isBoth ? raised.data && claimed.data : single.data;
//     const busy = isBoth ? raised.loading || claimed.loading : single.loading;
//     const err = isBoth ? raised.error || claimed.error : single.error;
//     const reload = () => {
//         if (stage === "raised" || isBoth) raised.reload();
//         if (stage === "claimed" || isBoth) claimed.reload();
//     };

//     // filter options hamesha raised data se aate hain
//     useEffect(() => {
//         const d = raised.data;
//         if (!d || f.project || f.month || f.year) return;
//         const ps = d.projects || [];
//         const uniq = (k) => [...new Set(ps.flatMap((p) => p[k] || []))].sort();
//         setOpts({ projects: ps.map((p) => ({ id: p.project_id, label: pLabel(p) })), months: uniq("months_available"), years: uniq("years_available") });
//     }, [raised.data, f.project, f.month, f.year]);

//     const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
//     const stages = [
//         ["raised", "Invoice raised"],
//         ["claimed", "Claims"],
//         ["both", "Raised + Claims"],
//         ["payment", "Payments & deductions"],
//     ];
//     const showCP = !!(f.month || f.year);
//     const errLabel = isBoth ? "raised + claim" : stage === "claimed" ? "claim" : "invoice";

//     return (
//         <div className="invd-root">
//             <header className="invd-head">
//                 <div>
//                     <h1 className="invd-title">Invoice dashboard</h1>
//                     <p className="invd-sub">
//                         {isBoth ? "Raised and claimed side by side, and what is still unclaimed." : "What has been raised, and what is left, across projects."}
//                     </p>
//                 </div>
//                 <div className="invd-filters">
//                     <Select value={f.project} onChange={set("project")}>
//                         <option value="">All projects</option>
//                         {opts.projects.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
//                     </Select>
//                     <Select value={f.month} onChange={set("month")}>
//                         <option value="">All months</option>
//                         {opts.months.map((m) => <option key={m} value={m}>{MONTHS[+m - 1] || m}</option>)}
//                     </Select>
//                     <Select value={f.year} onChange={set("year")}>
//                         <option value="">All years</option>
//                         {opts.years.map((y) => <option key={y} value={y}>{y}</option>)}
//                     </Select>
//                 </div>
//             </header>

//             <nav className="invd-tabs" style={{ "--idx": stages.findIndex(([k]) => k === stage), "--n": stages.length }}>
//                 {stages.map(([k, label]) => (
//                     <button key={k} onClick={() => setStage(k)} className={`invd-tab ${stage === k ? "on" : ""}`}>{label}</button>
//                 ))}
//             </nav>

//             {stage === "payment" ? (
//                 <div key={stage} className="invd-fade"><Soon name={stages.find(([k]) => k === stage)[1]} /></div>
//             ) : err ? (
//                 <div className="invd-err">
//                     <b>Could not load {errLabel} data</b>
//                     <p>{err}</p>
//                     <button onClick={reload}>Retry</button>
//                 </div>
//             ) : !ready && busy ? (
//                 <Skeleton />
//             ) : !ready ? (
//                 <Skeleton />
//             ) : isBoth ? (
//                 <div key={`both|${f.project}|${f.month}|${f.year}`} className={`invd-fade ${busy ? "invd-dim" : ""}`}>
//                     <CombinedView raised={raised.data} claimed={claimed.data} activeProject={f.project}
//                         onPickProject={set("project")} showCP={showCP} />
//                 </div>
//             ) : (
//                 <div key={`${stage}|${f.project}|${f.month}|${f.year}`} className={`invd-fade ${busy ? "invd-dim" : ""}`}>
//                     <RaisedView data={single.data} activeProject={f.project} onPickProject={set("project")}
//                         T={stage === "claimed" ? TXT.claimed : TXT.raised} showCP={showCP} />
//                 </div>
//             )}
//         </div>
//     );
// }



import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,
    PieChart, Pie, Cell, CartesianGrid,
    RadialBarChart, RadialBar, PolarAngleAxis,
    RadarChart, Radar, PolarGrid, PolarAngleAxis as RadarAngle, PolarRadiusAxis,
    ComposedChart, Line,
} from "recharts";
import "./dashboardcss/invoiceDashboard.css";
import { BASE_URL } from "../../config/axios";

/* ───────── constants & helpers ───────── */
const CATS = {
    employee: "Employee", transportation: "Transportation", duty_travel: "Duty travel",
    office_rent: "Office rent", office_supplies: "Office supplies",
    office_furniture_equipment: "Furniture & equipment", reports_documents: "Reports & documents",
    road_survey: "Road survey",
};
const SHORT = {
    employee: "Employee", transportation: "Transport", duty_travel: "Duty travel",
    office_rent: "Rent", office_supplies: "Supplies", office_furniture_equipment: "Furniture",
    reports_documents: "Reports", road_survey: "Survey",
};
const COLOR = {
    employee: "#0F766E", transportation: "#2F5D9E", duty_travel: "#7C5CBF", office_rent: "#D98E04",
    office_supplies: "#C2553F", office_furniture_equipment: "#3F8F5B", reports_documents: "#4A7FA7", road_survey: "#8795A9",
};
const C_RAISED = "#0F766E";
const C_CLAIMED = "#2F5D9E";
const FIELDS = ["current", "previous", "cumulative", "remaining", "eot_total_amount", "contract_amount", "ded_gross", "ded_released", "ded_net"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const FONT = "Inter, system-ui, sans-serif";
const TICK = { fontSize: 11, fill: "#6B7A90", fontFamily: FONT };
const ANIM = { animationDuration: 900, animationEasing: "ease-out" };

/* labels: Invoice raised vs Claims */
const TXT = {
    raised: {
        eyebrow: "Total raised · cumulative",
        vs: "current vs previous invoice", cnt: "Invoices",
        of: "of contract billed", billed: "Billed", noPrev: "No previous invoice",
        none: "No invoices raised yet.", nothing: "Nothing raised yet.", note: "Amount raised by category",
        progress: "Billing progress by category", noData: "No billing data yet.", cvb: "Contract vs billed",
        noProj: "No project billing yet.", tbl: "contract & billing", noInv: "Show projects with no invoices",
        csv: "projects.csv",
    },
    claimed: {
        eyebrow: "Total claimed · cumulative",
        vs: "current vs previous claim", cnt: "Claims",
        of: "of contract claimed", billed: "Claimed", noPrev: "No previous claim",
        none: "No claims raised yet.", nothing: "Nothing claimed yet.", note: "Amount claimed by category",
        progress: "Claim progress by category", noData: "No claim data yet.", cvb: "Contract vs claimed",
        noProj: "No project claims yet.", tbl: "contract & claims", noInv: "Show projects with no claims",
        csv: "claim-projects.csv",
    },
};

const CatTick = ({ x, y, payload }) => (
    <text x={x} y={y} textAnchor="middle" fill="#6B7A90" fontSize={11} fontFamily={FONT}>
        {String(payload.value).split(" ").map((w, i) => (
            <tspan key={i} x={x} dy={i ? 13 : 14}>{w}</tspan>
        ))}
    </text>
);

const n = (v) => +v || 0;
const inr = (v) => "₹" + Math.round(n(v)).toLocaleString("en-IN");
const short = (v) => {
    v = n(v);
    return v >= 1e7 ? `₹${(v / 1e7).toFixed(2)} Cr` : v >= 1e5 ? `₹${(v / 1e5).toFixed(2)} L` : inr(v);
};
const pct = (v) => `${n(v).toFixed(1)}%`;
const usedPct = (c) => (n(c.cumulative) + n(c.remaining) ? (n(c.cumulative) / (n(c.cumulative) + n(c.remaining))) * 100 : 0);
const ratio = (a, b) => (n(b) ? (n(a) / n(b)) * 100 : 0);
const pName = (p) => p.project_name || "Untitled project";
const pLabel = (p) => `${pName(p)}${p.location ? ` – ${p.location}` : ""} (${String(p.project_id).slice(0, 4)})`;
const trunc = (s, l = 18) => (s.length > l ? s.slice(0, l - 1) + "…" : s);
const initials = (s) => s.split(/\s+|&/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

const sumCats = (projects) => Object.entries(CATS).map(([key, name]) => {
    const o = { key, name };
    FIELDS.forEach((f) => { o[f] = projects.reduce((a, p) => a + n(p.categories?.[key]?.[f]), 0); });
    return o;
});

/* ───────── deductions & releases ───────── */
const rowsOf = (d) => (Array.isArray(d) ? d : d?.data || d?.results || []);

// category name/key -> category key ("employee", "Office rent", "office_rent", ...)
const normKey = (x) => String(x).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
const CAT_MAP = (() => {
    const m = {};
    Object.entries(CATS).forEach(([k, label]) => {
        m[k] = k;
        m[normKey(label)] = k;
        if (k.startsWith("office_")) m[k.slice(7)] = k;
    });
    return m;
})();
const CAT_ALIASES = Object.keys(CAT_MAP);
const SKIP_KEYS = new Set(["invoice_data", "id", "item_id", "invoice_id", "project", "created_at", "updated_at"]);

// deduction row (ya uske nested related_item_data) me se category dhundho
function findCat(o, depth = 0) {
    if (o == null || depth > 4) return null;
    if (typeof o === "string") return CAT_MAP[normKey(o)] || null;
    if (typeof o !== "object") return null;
    if (Array.isArray(o)) {
        for (const x of o) { const r = findCat(x, depth + 1); if (r) return r; }
        return null;
    }
    for (const [k, v] of Object.entries(o)) {
        if (SKIP_KEYS.has(k) || v == null || v === "" || v === false) continue;
        const nk = normKey(k);
        const hit = CAT_ALIASES.find((a) => nk === a || nk.startsWith(a + "_"));
        if (hit) return CAT_MAP[hit];
        const r = findCat(v, depth + 1);
        if (r) return r;
    }
    return null;
}
const catOf = (d) => findCat(d);

// project_id -> { gross, released, net, unassigned, byCat: { key: {gross, released, net} } }
function buildDeductions(deds, rels) {
    // release ko deduction_id se group karo
    const relBy = {};
    rels.forEach((r) => {
        const id = r.deduction_id || r.deduction_data?.id;
        if (!id) return;
        relBy[id] = (relBy[id] || 0) + n(r.deduction_amount) + n(r.withheld_release_amount);
    });

    const byProject = {};
    deds.forEach((d) => {
        const pid = d.project || d.invoice_data?.project;
        const gross = n(d.deduction_amount) + n(d.withheld_deduction_amount);
        if (!pid || !gross) return;                         // null/empty rows skip
        const released = Math.min(relBy[d.id] || 0, gross); // release deduction se zyada nahi ho sakta
        const net = gross - released;                       // 1000 deduction, 500 release → 500 deduction
        const o = byProject[pid] || (byProject[pid] = { gross: 0, released: 0, net: 0, unassigned: 0, byCat: {} });
        o.gross += gross;
        o.released += released;
        o.net += net;
        const k = catOf(d);
        if (k) {
            const c = o.byCat[k] || (o.byCat[k] = { gross: 0, released: 0, net: 0 });
            c.gross += gross; c.released += released; c.net += net;
        } else {
            o.unassigned += net;
            console.warn("deduction category not found, row:", d);
        }
    });
    return byProject;
}

// raised data me se net deduction minus karo (sirf jab month/year null ho)
// addCum = true: net deduction cumulative me wapas jod do (Raised + Claims me deduction "unclaimed" me dikhe)
function applyDeductions(data, byProject, addCum = false) {
    if (!data) return { data, ded: null };
    let gross = 0, released = 0, net = 0, unassigned = 0;
    const projects = (data.projects || []).map((p) => {
        const o = byProject[p.project_id];
        if (!o) return p;
        gross += o.gross; released += o.released; net += o.net; unassigned += o.unassigned;
        const categories = { ...p.categories };
        Object.entries(o.byCat).forEach(([k, v]) => {
            const c = categories[k] || {};
            categories[k] = {
                ...c,
                current: n(c.current) - v.net,
                cumulative: n(c.cumulative) + (addCum ? v.net : 0),
                remaining: n(c.remaining) - (addCum ? v.net : 0),
                ded_gross: n(c.ded_gross) + v.gross,
                ded_released: n(c.ded_released) + v.released,
                ded_net: n(c.ded_net) + v.net,
            };
        });
        return {
            ...p,
            totals: {
                ...p.totals,
                current: n(p.totals?.current) - o.net,
                cumulative: n(p.totals?.cumulative) + (addCum ? o.net : 0),
                remaining: n(p.totals?.remaining) - (addCum ? o.net : 0),
            },
            categories,
        };
    });
    return {
        data: {
            ...data,
            projects,
            summary: {
                ...data.summary,
                current: n(data.summary?.current) - net,
                cumulative: n(data.summary?.cumulative) + (addCum ? net : 0),
                remaining: n(data.summary?.remaining) - (addCum ? net : 0),
            },
        },
        ded: { gross, released, net, unassigned },
    };
}
const dedSub = (d) => `Gross ${short(d.gross)}${d.unassigned ? ` · ${short(d.unassigned)} category unknown` : ""}`;

/* ───────── hooks ───────── */
function useCountUp(target, dur = 900) {
    const [v, setV] = useState(0);
    const last = useRef(0);
    useEffect(() => {
        const from = last.current, to = n(target), t0 = performance.now();
        let raf;
        const step = (t) => {
            const p = Math.min((t - t0) / dur, 1);
            const val = from + (to - from) * (1 - Math.pow(1 - p, 3));
            last.current = val;
            setV(val);
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
    }, [target, dur]);
    return v;
}

function useInvoiceDashboard(http, baseUrl, f, enabled = true) {
    const [st, setSt] = useState({ data: null, loading: true, error: null });
    const [tick, setTick] = useState(0);
    useEffect(() => {
        if (!enabled) return;
        let alive = true;
        setSt((s) => ({ ...s, loading: true, error: null }));
        http.get(`${baseUrl}/${f.project || "null"}/${f.month || "null"}/${f.year || "null"}/`)
            .then((r) => {
                if (!alive) return;
                if (r.data?.success === false) throw new Error(r.data?.message || "API returned success: false");
                setSt({ data: r.data, loading: false, error: null });
            })
            .catch((e) => alive && setSt({ data: null, loading: false, error: e?.response?.data?.message || e.message || "Request failed" }));
        return () => { alive = false; };
    }, [http, baseUrl, f.project, f.month, f.year, tick, enabled]);
    return { ...st, reload: () => setTick((t) => t + 1) };
}

// deduction + release fetch (siteproject/invoicedeductionfilter & invoiceDeductionReleaseByProject)
function useDeductions(http, dedUrl, relUrl, project, enabled) {
    const [map, setMap] = useState({});
    useEffect(() => {
        if (!enabled) return;
        let alive = true;
        const pid = project || "null";
        Promise.all([
            http.get(`${dedUrl}/${pid}/null/null/`),
            http.get(`${relUrl}/${pid}/`),
        ])
            .then(([a, b]) => alive && setMap(buildDeductions(rowsOf(a.data), rowsOf(b.data))))
            .catch((e) => { console.warn("deduction fetch failed", e); alive && setMap({}); });
        return () => { alive = false; };
    }, [http, dedUrl, relUrl, project, enabled]);
    return map;
}

/* ───────── small pieces ───────── */
const Panel = ({ title, note, children, i = 0, className = "" }) => (
    <section className={`invd-panel ${className}`} style={{ "--i": i }}>
        <div className="invd-ph"><h3>{title}</h3>{note && <span>{note}</span>}</div>
        {children}
    </section>
);

const Stat = ({ label, value, sub, tone, i = 0, raw }) => {
    const v = useCountUp(value);
    return (
        <div className="invd-stat" style={{ "--i": i }}>
            <p>{label}</p>
            <strong>{raw ? Math.round(v) : short(v)}</strong>
            {sub && <span className={tone || ""}>{sub}</span>}
        </div>
    );
};

const Select = ({ value, onChange, children }) => (
    <select className="invd-select" value={value} onChange={(e) => onChange(e.target.value)}>{children}</select>
);

const Tip = ({ active, payload, label, fmt = inr }) => {
    const items = (payload || []).filter((p) => n(p.value));
    return active && items.length ? (
        <div className="invd-tip">
            <p className="h">{items[0].payload?.name ?? label}</p>
            {items.map((p) => (
                <p key={p.dataKey || p.name}>
                    <span><i className="invd-dot" style={{ background: p.color || p.payload?.fill }} />{p.name}</span>
                    <b>{fmt(p.value)}</b>
                </p>
            ))}
        </div>
    ) : null;
};

const Meter = ({ pct: p, color }) => (
    <div className="invd-meter"><i style={{ width: `${Math.min(p, 100)}%`, background: color }} /></div>
);

const status = (p) => (p >= 90 ? ["Near limit", "bad"] : p >= 50 ? ["On track", "mid"] : p > 0 ? ["Started", "ok"] : ["Not started", "off"]);
const Pill = ({ p }) => { const [t, k] = status(p); return <em className={`invd-pill ${k}`}>{t}</em>; };

const Ring = ({ value }) => {
    const r = 48, c = 2 * Math.PI * r, v = Math.min(n(value), 100);
    return (
        <svg className="invd-ring" width="132" height="132" viewBox="0 0 120 120" style={{ "--c": c, "--o": c - (c * v) / 100 }}>
            <circle cx="60" cy="60" r={r} className="trk" />
            <circle cx="60" cy="60" r={r} className="val" strokeDasharray={c} />
            <text x="60" y="67" textAnchor="middle">{v.toFixed(1)}%</text>
        </svg>
    );
};

// Hero hamesha "Total raised · cumulative" dikhata hai (deduction se untouched)
const Hero = ({ s, utilAll, delta, hasPrev, activeCount, invoices, T }) => {
    const v = useCountUp(s.cumulative);
    return (
        <div className="invd-hero">
            <div className="invd-hero-l">
                <span className="invd-eyebrow">{T.eyebrow}</span>
                <h2>{short(v)}</h2>
                <div className="invd-hero-meta">
                    <span className={`invd-delta ${delta >= 0 ? "up" : "down"}`}>
                        {hasPrev ? `${delta >= 0 ? "▲" : "▼"} ${Math.abs(delta).toFixed(1)}%` : "New"}
                    </span>
                    <span>{T.vs}</span>
                </div>
                <div className="invd-hero-chips">
                    <div><small>Remaining</small><b>{short(s.remaining)}</b></div>
                    <div><small>Active projects</small><b>{activeCount} / {n(s.total_projects)}</b></div>
                    <div><small>{T.cnt}</small><b>{invoices}</b></div>
                </div>
            </div>
            <div className="invd-hero-r"><Ring value={utilAll} /><span>{T.of}</span></div>
        </div>
    );
};

const exportCsv = (rows, T, showCP = true) => {
    const head = ["Project", "Location", T.cnt, "Current", "Previous", ...(showCP ? ["Cumulative"] : []), "Remaining"];
    const body = rows.map((p) => [pName(p), p.location || "", (p.invoice_ids || []).length,
    n(p.totals?.current), n(p.totals?.previous), ...(showCP ? [n(p.totals?.cumulative)] : []), n(p.totals?.remaining)]);
    const csv = [head, ...body].map((r) => r.map((x) => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = T.csv;
    a.click();
};

const exportBothCsv = (rows) => {
    const head = ["Project", "Location", "Invoices", "Claims", "Raised", "Claimed", "Unclaimed", "Claimed %"];
    const body = rows.map((r) => [r.name, r.location, r.rInv, r.cInv, r.rCum, r.cCum, r.gap, r.pct.toFixed(2)]);
    const csv = [head, ...body].map((r) => r.map((x) => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "raised-vs-claimed.csv";
    a.click();
};

const Skeleton = () => (
    <div className="invd-stack">
        <div className="invd-skel h130" />
        <div className="invd-stats">{[...Array(3)].map((_, i) => <div key={i} className="invd-skel h90" />)}</div>
        <div className="invd-cards">{[...Array(8)].map((_, i) => <div key={i} className="invd-skel h130" />)}</div>
        <div className="invd-grid"><div className="invd-skel h320" /><div className="invd-skel h320" /></div>
    </div>
);

/* ───────── main view (raised / claimed) ───────── */
function RaisedView({ data, ded = null, onPickProject, activeProject, T = TXT.raised, showCP = true }) {
    const [cat, setCat] = useState("all");
    const [showEmpty, setShowEmpty] = useState(false);
    const [q, setQ] = useState("");
    const [hover, setHover] = useState(null);
    const s = data.summary || {};
    const projects = data.projects || [];

    const active = useMemo(() => projects.filter((p) => n(p.totals?.cumulative) || (p.invoice_ids || []).length), [projects]);
    const cats = useMemo(() => sumCats(projects), [projects]);
    const cur = n(s.current), prev = n(s.previous);
    const delta = prev ? ((cur - prev) / prev) * 100 : 0;
    const utilAll = usedPct({ cumulative: s.cumulative, remaining: s.remaining });
    const invoiceCount = projects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
    const contractEot = cats.reduce((a, c) => a + c.eot_total_amount, 0);

    const compare = cats.map((c) => ({ name: c.name, label: SHORT[c.key], Previous: c.previous, Current: c.current }));
    const share = cats.filter((c) => c.current > 0).map((c) => ({ name: c.name, value: c.current, key: c.key }));
    const shareTotal = share.reduce((a, d) => a + d.value, 0);

    const stacked = cats.filter((c) => c.cumulative || c.remaining).map((c) => ({ name: c.name, Cumulative: c.cumulative, Remaining: c.remaining }));
    const contract = cats.filter((c) => c.eot_total_amount || c.contract_amount)
        .map((c) => ({ name: c.name, label: SHORT[c.key], "Contract (EOT)": c.eot_total_amount, "Contract amount": c.contract_amount, Cumulative: c.cumulative }));
    const radar = cats.map((c) => ({ name: c.name, Used: +usedPct(c).toFixed(2) }));
    const hasRadar = radar.some((r) => r.Used > 0);
    const topProjects = projects.filter((p) => n(p.totals?.cumulative) || n(p.totals?.remaining))
        .sort((a, b) => n(b.totals?.cumulative) - n(a.totals?.cumulative)).slice(0, 8)
        .map((p) => ({ id: p.project_id, name: trunc(pName(p)), Cumulative: n(p.totals?.cumulative), Remaining: n(p.totals?.remaining) }));

    const tableCats = cat === "all" ? cats : cats.filter((c) => c.key === cat);
    const tableProjects = (showEmpty ? projects : active)
        .filter((p) => `${pName(p)} ${p.location || ""}`.toLowerCase().includes(q.trim().toLowerCase()))
        .slice().sort((a, b) => n(b.totals?.cumulative) - n(a.totals?.cumulative));
    const hv = hover != null ? share[hover] : null;

    // category table footer columns (cumulative tab hide when month/year null)
    const footFields = ["eot_total_amount", "contract_amount", "previous", "current", "cumulative", "remaining"]
        .filter((f) => showCP || f !== "cumulative");

    return (
        <div className="invd-stack">
            <Hero s={s} utilAll={utilAll} delta={delta} hasPrev={!!prev} activeCount={active.length} invoices={invoiceCount} T={T} />

            <div className="invd-stats">
                {showCP && (
                    <>
                        <Stat i={0} label="Current" value={cur}
                            sub={prev ? `${delta >= 0 ? "▲" : "▼"} ${Math.abs(delta).toFixed(1)}% vs previous` : T.noPrev}
                            tone={delta >= 0 ? "up" : "down"} />
                        <Stat i={1} label="Previous" value={prev} sub={inr(prev)} />
                    </>
                )}
                <Stat i={2} label="Contract (EOT)" value={contractEot} sub="Total extension-of-time amount" />
                {ded && (
                    <>
                        <Stat i={3} label="Deducted (net)" value={ded.net} sub={dedSub(ded)} tone="down" />
                        <Stat i={4} label="Released" value={ded.released} sub="Deduction me se wapas" tone="up" />
                    </>
                )}
            </div>

            <div className="invd-cards">
                {cats.map((c, i) => (
                    <button type="button" key={c.key} style={{ "--c": COLOR[c.key], "--i": i }}
                        className={`invd-card ${cat === c.key ? "on" : ""} ${c.cumulative ? "" : "zero"}`}
                        onClick={() => setCat((x) => (x === c.key ? "all" : c.key))}>
                        <div className="invd-card-top">
                            <span className="invd-mono">{initials(c.name)}</span>
                            <h4>{c.name}</h4>
                            <Pill p={usedPct(c)} />
                        </div>
                        <strong>{short(c.current)}</strong>
                        <span className="invd-card-sub">current · previous {short(c.previous)}</span>
                        <Meter pct={usedPct(c)} color={COLOR[c.key]} />
                        <div className="invd-card-foot">
                            <span>{usedPct(c).toFixed(2)}% used</span>
                            <span>Remaining {short(c.remaining)}</span>
                        </div>
                    </button>
                ))}
            </div>

            {/* row 1 */}
            <div className="invd-grid">
                <Panel i={0} title="Current vs previous" note={T.note}>
                    {compare.length ? (
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={compare} margin={{ left: 4, right: 8, top: 8 }}>
                                    <defs>
                                        <linearGradient id="gCur" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#14B8A6" /><stop offset="100%" stopColor="#0F766E" />
                                        </linearGradient>
                                        <linearGradient id="gPrev" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="0%" stopColor="#B4C1D2" /><stop offset="100%" stopColor="#8FA0B5" />
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                    <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
                                    <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
                                    <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Bar dataKey="Previous" fill="url(#gPrev)" radius={[6, 6, 0, 0]} maxBarSize={30} {...ANIM} />
                                    <Bar dataKey="Current" fill="url(#gCur)" radius={[6, 6, 0, 0]} maxBarSize={30} {...ANIM} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : <div className="invd-empty">{T.none}</div>}
                </Panel>

                <Panel i={1} title="Share of current amount" note="Hover a slice">
                    {share.length ? (
                        <>
                            <div className="invd-donut">
                                <ResponsiveContainer width="100%" height="100%">
                                    <PieChart>
                                        <Pie data={share} dataKey="value" innerRadius={62} outerRadius={90} paddingAngle={3} cornerRadius={5}
                                            stroke="none" onMouseEnter={(_, i) => setHover(i)} onMouseLeave={() => setHover(null)} {...ANIM}>
                                            {share.map((d, i) => (
                                                <Cell key={d.key} fill={COLOR[d.key]}
                                                    style={{ transition: "opacity .2s", opacity: hover == null || hover === i ? 1 : 0.35, outline: "none" }} />
                                            ))}
                                        </Pie>
                                    </PieChart>
                                </ResponsiveContainer>
                                <div className="invd-donut-c" key={hv ? hv.key : "all"}>
                                    <span>{hv ? hv.name : "Total"}</span>
                                    <b>{short(hv ? hv.value : shareTotal)}</b>
                                    {hv && <em>{((hv.value / shareTotal) * 100).toFixed(1)}%</em>}
                                </div>
                            </div>
                            <ul className="invd-legend">
                                {share.map((d, i) => (
                                    <li key={d.key} className={hover === i ? "hl" : ""} onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(null)}>
                                        <span><i style={{ background: COLOR[d.key] }} />{d.name}</span>
                                        <b>{((d.value / shareTotal) * 100).toFixed(1)}%</b>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : <div className="invd-empty">{T.nothing}</div>}
                </Panel>
            </div>

            {/* row 2 */}
            <div className="invd-grid">
                <Panel i={2} title={T.progress} note="Cumulative vs remaining">
                    {stacked.length ? (
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={stacked} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
                                    <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                    <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
                                    <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={120} />
                                    <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Bar dataKey="Cumulative" stackId="a" fill="#0F766E" maxBarSize={20} {...ANIM} />
                                    <Bar dataKey="Remaining" stackId="a" fill="#D5DEE9" radius={[0, 6, 6, 0]} maxBarSize={20} {...ANIM} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : <div className="invd-empty">{T.noData}</div>}
                </Panel>

                <Panel i={3} title="Overall utilization" note="Cumulative ÷ (cumulative + remaining)">
                    <div className="invd-donut gauge">
                        <ResponsiveContainer width="100%" height="100%">
                            <RadialBarChart innerRadius="72%" outerRadius="100%" data={[{ name: "Used", value: Math.min(utilAll, 100), fill: "#0F766E" }]}
                                startAngle={210} endAngle={-30}>
                                <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                                <RadialBar dataKey="value" cornerRadius={12} background={{ fill: "#EDF1F5" }} {...ANIM} />
                            </RadialBarChart>
                        </ResponsiveContainer>
                        <div className="invd-donut-c"><b className="big">{utilAll.toFixed(1)}%</b><span>{T.of}</span></div>
                    </div>
                    <div className="invd-minis">
                        <div><span>{T.billed}</span><b>{short(s.cumulative)}</b></div>
                        <div><span>Left</span><b>{short(s.remaining)}</b></div>
                    </div>
                </Panel>
            </div>

            {/* row 3 */}
            <div className="invd-grid even">
                <Panel i={4} title={T.cvb} note="EOT, BOQ and cumulative">
                    {contract.length ? (
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <ComposedChart data={contract} margin={{ left: 4, right: 8, top: 8 }}>
                                    <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                    <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
                                    <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
                                    <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Bar dataKey="Contract (EOT)" fill="#2F5D9E" radius={[6, 6, 0, 0]} maxBarSize={22} {...ANIM} />
                                    <Bar dataKey="Contract amount" fill="#D98E04" radius={[6, 6, 0, 0]} maxBarSize={22} {...ANIM} />
                                    <Line type="monotone" dataKey="Cumulative" stroke="#0F766E" strokeWidth={2.5}
                                        dot={{ r: 4, fill: "#fff", strokeWidth: 2 }} activeDot={{ r: 6 }} {...ANIM} />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    ) : <div className="invd-empty">No contract data.</div>}
                </Panel>

                <Panel i={5} title="Utilization radar" note="% used per category">
                    {hasRadar ? (
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <RadarChart data={radar} outerRadius="72%">
                                    <PolarGrid stroke="#E3E9F0" />
                                    <RadarAngle dataKey="name" tick={{ ...TICK, fontSize: 10.5 }} />
                                    <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ ...TICK, fontSize: 9 }} axisLine={false} />
                                    <Tooltip content={<Tip fmt={pct} />} />
                                    <Radar name="Used" dataKey="Used" stroke="#0F766E" fill="#0F766E" fillOpacity={0.28} strokeWidth={2} {...ANIM} />
                                </RadarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : <div className="invd-empty">No utilization yet.</div>}
                </Panel>
            </div>

            {/* row 4 */}
            <Panel i={6} title="Top projects" note="Click a bar to filter by project">
                {topProjects.length ? (
                    <div className="invd-chart tall">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={topProjects} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
                                <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
                                <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={130} />
                                <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                <Bar dataKey="Cumulative" stackId="p" fill="#2F5D9E" maxBarSize={18} cursor="pointer"
                                    onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM}>
                                    {topProjects.map((d) => <Cell key={d.id} fill={activeProject === d.id ? "#0F766E" : "#2F5D9E"} />)}
                                </Bar>
                                <Bar dataKey="Remaining" stackId="p" fill="#D5DEE9" radius={[0, 6, 6, 0]} maxBarSize={18} {...ANIM} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                ) : <div className="invd-empty">{T.noProj}</div>}
            </Panel>

            {/* category table */}
            <Panel i={7} title={`${cat === "all" ? "All categories" : CATS[cat]}: ${T.tbl}`} note={ded ? "Current is net of deductions" : undefined}>
                <div className="invd-tw">
                    <table className="invd-table">
                        <thead>
                            <tr>
                                <th>Category</th><th className="r">Contract (EOT)</th><th className="r">BOQ rate</th>
                                <th className="r">Previous</th><th className="r">Current</th>
                                {showCP && <th className="r">Cumulative</th>}
                                <th className="r">Remaining</th>
                                {ded && <><th className="r">Deducted</th><th className="r">Released</th></>}
                                <th>Used</th>
                            </tr>
                        </thead>
                        <tbody key={cat}>
                            {tableCats.map((c, i) => (
                                <tr key={c.key} style={{ "--i": i }}>
                                    <td><span className="invd-dot" style={{ background: COLOR[c.key] }} /><b>{c.name}</b></td>
                                    <td className="r">{inr(c.eot_total_amount)}</td>
                                    <td className="r">{inr(c.contract_amount)}</td>
                                    <td className="r">{inr(c.previous)}</td>
                                    <td className="r amt">{inr(c.current)}</td>
                                    {showCP && <td className="r">{inr(c.cumulative)}</td>}
                                    <td className="r">{inr(c.remaining)}</td>
                                    {ded && <><td className="r">{inr(c.ded_net)}</td><td className="r">{inr(c.ded_released)}</td></>}
                                    <td className="usedcell"><Meter pct={usedPct(c)} color={COLOR[c.key]} /><small>{usedPct(c).toFixed(2)}%</small></td>
                                </tr>
                            ))}
                            {/* category resolve nahi hui deduction: gap explain karne ke liye */}
                            {ded?.unassigned > 0 && cat === "all" && (
                                <tr className="dim">
                                    <td><span className="invd-dot" style={{ background: "#B4C1D2" }} /><b>Unassigned deduction</b></td>
                                    <td className="r" colSpan={showCP ? 6 : 5}>Category not found</td>
                                    <td className="r">{inr(ded.unassigned)}</td>
                                    <td className="r">{inr(0)}</td>
                                    <td />
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                {footFields.map((f) => (
                                    <td key={f} className="r">{inr(tableCats.reduce((a, c) => a + c[f], 0))}</td>
                                ))}
                                {ded && <><td className="r">{inr(tableCats.reduce((a, c) => a + c.ded_net, 0) + (cat === "all" ? n(ded.unassigned) : 0))}</td><td className="r">{inr(tableCats.reduce((a, c) => a + c.ded_released, 0))}</td></>}
                                <td />
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Panel>

            {/* projects table */}
            <Panel i={8} title="Projects" note={`${tableProjects.length} of ${projects.length} shown`}>
                <div className="invd-toolbar">
                    <input className="invd-input" placeholder="Search project or location…" value={q} onChange={(e) => setQ(e.target.value)} />
                    <label className="invd-check">
                        <input type="checkbox" checked={showEmpty} onChange={(e) => setShowEmpty(e.target.checked)} />
                        {T.noInv}
                    </label>
                    <button type="button" className="invd-btn" onClick={() => exportCsv(tableProjects, T, showCP)}>Export CSV</button>
                </div>
                <div className="invd-tw">
                    <table className="invd-table">
                        <thead>
                            <tr>
                                <th>Project</th><th>Location</th><th className="r">{T.cnt}</th><th>Months</th>
                                <th className="r">Current</th><th className="r">Previous</th>
                                {showCP && <th className="r">Cumulative</th>}
                                <th className="r">Remaining</th>
                            </tr>
                        </thead>
                        <tbody key={`${showEmpty}|${q}`}>
                            {tableProjects.map((p, i) => (
                                <tr key={p.project_id} style={{ "--i": Math.min(i, 20), cursor: "pointer" }}
                                    className={`${n(p.totals?.cumulative) ? "" : "dim"} ${activeProject === p.project_id ? "sel" : ""}`}
                                    onClick={() => onPickProject(activeProject === p.project_id ? "" : p.project_id)}>
                                    <td><b>{pName(p)}</b></td>
                                    <td>{p.location || "—"}</td>
                                    <td className="r">{(p.invoice_ids || []).length}</td>
                                    <td>{(p.months_available || []).map((m) => MONTHS[+m - 1]).join(", ")} {(p.years_available || []).join(", ")}</td>
                                    <td className="r amt">{inr(p.totals?.current)}</td>
                                    <td className="r">{inr(p.totals?.previous)}</td>
                                    {showCP && <td className="r">{inr(p.totals?.cumulative)}</td>}
                                    <td className="r">{inr(p.totals?.remaining)}</td>
                                </tr>
                            ))}
                            {!tableProjects.length && <tr><td colSpan={showCP ? 8 : 7}><div className="invd-empty">No projects to show.</div></td></tr>}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}

/* ───────── combined view (raised + claimed) ───────── */
function CombinedView({ raised, claimed, ded = null, onPickProject, activeProject, showCP = true }) {
    const [cat, setCat] = useState("all");
    const [showEmpty, setShowEmpty] = useState(false);
    const [q, setQ] = useState("");

    const rs = raised.summary || {}, cs = claimed.summary || {};
    const rProjects = raised.projects || [], cProjects = claimed.projects || [];

    const rCats = useMemo(() => sumCats(rProjects), [rProjects]);
    const cCats = useMemo(() => sumCats(cProjects), [cProjects]);
    const cats = useMemo(() => rCats.map((r, i) => {
        const c = cCats[i] || {};
        return {
            key: r.key, name: r.name,
            rCum: r.cumulative, cCum: n(c.cumulative),
            rCur: r.current, cCur: n(c.current),
            rPrev: r.previous, cPrev: n(c.previous),
            rRem: r.remaining, cRem: n(c.remaining),
            rUsed: usedPct(r), cUsed: usedPct(c),
            eot: r.eot_total_amount, boq: r.contract_amount,
            dNet: n(r.ded_net), dRel: n(r.ded_released),
            gap: r.cumulative - n(c.cumulative),
            pct: ratio(c.cumulative, r.cumulative),
        };
    }), [rCats, cCats]);

    const rows = useMemo(() => {
        const map = new Map();
        rProjects.forEach((p) => map.set(p.project_id, { id: p.project_id, name: pName(p), location: p.location || "", rInv: (p.invoice_ids || []).length, cInv: 0, rCum: n(p.totals?.cumulative), cCum: 0 }));
        cProjects.forEach((p) => {
            const o = map.get(p.project_id) || { id: p.project_id, name: pName(p), location: p.location || "", rInv: 0, rCum: 0 };
            o.cInv = (p.invoice_ids || []).length;
            o.cCum = n(p.totals?.cumulative);
            map.set(p.project_id, o);
        });
        return [...map.values()].map((r) => ({ ...r, gap: r.rCum - r.cCum, pct: ratio(r.cCum, r.rCum) }));
    }, [rProjects, cProjects]);

    const rCum = n(rs.cumulative), cCum = n(cs.cumulative), gap = rCum - cCum;
    const claimPct = ratio(cCum, rCum);
    const rInv = rProjects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
    const cInv = cProjects.reduce((a, p) => a + (p.invoice_ids || []).length, 0);
    const activeCount = rows.filter((r) => r.rCum || r.cCum).length;
    const eotTotal = cats.reduce((a, c) => a + c.eot, 0);

    const v = useCountUp(rCum);

    const byCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], Raised: c.rCum, Claimed: c.cCum }));
    const curCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], "Raised (current)": c.rCur, "Claimed (current)": c.cCur }));
    const remCat = cats.map((c) => ({ name: c.name, label: SHORT[c.key], "Raised (remaining)": c.rRem, "Claimed (remaining)": c.cRem }));
    const radar = cats.map((c) => ({ name: c.name, Raised: +c.rUsed.toFixed(2), Claimed: +c.cUsed.toFixed(2) }));
    const hasRadar = radar.some((r) => r.Raised > 0 || r.Claimed > 0);
    const topProjects = rows.filter((r) => r.rCum || r.cCum).sort((a, b) => b.rCum - a.rCum).slice(0, 8)
        .map((r) => ({ id: r.id, name: trunc(r.name), Raised: r.rCum, Claimed: r.cCum }));

    const tableCats = cat === "all" ? cats : cats.filter((c) => c.key === cat);
    const tableRows = (showEmpty ? rows : rows.filter((r) => r.rCum || r.cCum || r.rInv || r.cInv))
        .filter((r) => `${r.name} ${r.location}`.toLowerCase().includes(q.trim().toLowerCase()))
        .slice().sort((a, b) => b.rCum - a.rCum);

    return (
        <div className="invd-stack">
            {/* hero */}
            <div className="invd-hero">
                <div className="invd-hero-l">
                    <span className="invd-eyebrow">Total raised · cumulative</span>
                    <h2>{short(v)}</h2>
                    <div className="invd-hero-meta">
                        <span className={`invd-delta ${gap > 0 ? "down" : "up"}`}>{short(Math.abs(gap))} {gap >= 0 ? "unclaimed" : "over-claimed"}</span>
                        <span>raised minus claimed</span>
                    </div>
                    <div className="invd-hero-chips">
                        <div><small>Claimed</small><b>{short(cCum)}</b></div>
                        <div><small>Active projects</small><b>{activeCount} / {n(rs.total_projects)}</b></div>
                        <div><small>Invoices</small><b>{rInv}</b></div>
                        <div><small>Claims</small><b>{cInv}</b></div>
                    </div>
                </div>
                <div className="invd-hero-r"><Ring value={claimPct} /><span>of raised amount claimed</span></div>
            </div>

            {/* stats */}
            <div className="invd-stats">
                <Stat i={0} label="Raised (cumulative)" value={rCum} sub={`Remaining ${short(rs.remaining)}`} />
                <Stat i={1} label="Claimed (cumulative)" value={cCum} sub={`Remaining ${short(cs.remaining)}`} />
                <Stat i={2} label={gap >= 0 ? "Unclaimed" : "Over-claimed"} value={Math.abs(gap)} sub={`${claimPct.toFixed(1)}% claimed`} tone={gap > 0 ? "down" : "up"} />
                {showCP && <Stat i={3} label="Raised (current)" value={n(rs.current)} sub={`Previous ${short(rs.previous)}`} />}
                {showCP && <Stat i={4} label="Claimed (current)" value={n(cs.current)} sub={`Previous ${short(cs.previous)}`} />}
                <Stat i={5} label="Contract (EOT)" value={eotTotal} sub="Total extension-of-time amount" />
                {ded && (
                    <>
                        <Stat i={6} label="Deducted (net)" value={ded.net} sub={dedSub(ded)} tone="down" />
                        <Stat i={7} label="Released" value={ded.released} sub="Deduction me se wapas" tone="up" />
                    </>
                )}
            </div>

            {/* category cards */}
            <div className="invd-cards">
                {cats.map((c, i) => (
                    <button type="button" key={c.key} style={{ "--c": COLOR[c.key], "--i": i }}
                        className={`invd-card ${cat === c.key ? "on" : ""} ${c.rCum || c.cCum ? "" : "zero"}`}
                        onClick={() => setCat((x) => (x === c.key ? "all" : c.key))}>
                        <div className="invd-card-top">
                            <span className="invd-mono">{initials(c.name)}</span>
                            <h4>{c.name}</h4>
                            <Pill p={c.pct} />
                        </div>
                        <strong>{short(c.rCum)}</strong>
                        <span className="invd-card-sub">raised · claimed {short(c.cCum)}</span>
                        <Meter pct={c.pct} color={COLOR[c.key]} />
                        <div className="invd-card-foot">
                            <span>{c.pct.toFixed(2)}% claimed</span>
                            <span>{c.gap >= 0 ? "Unclaimed" : "Over"} {short(Math.abs(c.gap))}</span>
                        </div>
                    </button>
                ))}
            </div>

            {/* row 1 */}
            <div className="invd-grid">
                <Panel i={0} title="Raised vs claimed" note="Cumulative by category">
                    <div className="invd-chart">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={byCat} margin={{ left: 4, right: 8, top: 8 }}>
                                <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
                                <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
                                <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                <Bar dataKey="Raised" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                                <Bar dataKey="Claimed" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </Panel>

                <Panel i={1} title="Claim coverage" note="Claimed ÷ raised">
                    <div className="invd-donut gauge">
                        <ResponsiveContainer width="100%" height="100%">
                            <RadialBarChart innerRadius="72%" outerRadius="100%" data={[{ name: "Claimed", value: Math.min(claimPct, 100), fill: C_CLAIMED }]}
                                startAngle={210} endAngle={-30}>
                                <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                                <RadialBar dataKey="value" cornerRadius={12} background={{ fill: "#EDF1F5" }} {...ANIM} />
                            </RadialBarChart>
                        </ResponsiveContainer>
                        <div className="invd-donut-c"><b className="big" style={{ color: C_CLAIMED }}>{claimPct.toFixed(1)}%</b><span>of raised claimed</span></div>
                    </div>
                    <div className="invd-minis">
                        <div><span>Raised</span><b>{short(rCum)}</b></div>
                        <div><span>Claimed</span><b>{short(cCum)}</b></div>
                    </div>
                </Panel>
            </div>

            {/* row 2 */}
            <div className="invd-grid even">
                {showCP ? (
                    <Panel i={2} title="Current: raised vs claimed" note="Amount in selected period">
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={curCat} margin={{ left: 4, right: 8, top: 8 }}>
                                    <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                    <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
                                    <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
                                    <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Bar dataKey="Raised (current)" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                                    <Bar dataKey="Claimed (current)" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Panel>
                ) : (
                    <Panel i={2} title="Remaining: raised vs claimed" note="Balance left by category">
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={remCat} margin={{ left: 4, right: 8, top: 8 }}>
                                    <CartesianGrid vertical={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                    <XAxis dataKey="label" tick={<CatTick />} height={44} axisLine={false} tickLine={false} interval={0} />
                                    <YAxis tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} width={70} />
                                    <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Bar dataKey="Raised (remaining)" fill={C_RAISED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                                    <Bar dataKey="Claimed (remaining)" fill={C_CLAIMED} radius={[6, 6, 0, 0]} maxBarSize={24} {...ANIM} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Panel>
                )}

                <Panel i={3} title="Utilization radar" note="% used per category">
                    {hasRadar ? (
                        <div className="invd-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <RadarChart data={radar} outerRadius="72%">
                                    <PolarGrid stroke="#E3E9F0" />
                                    <RadarAngle dataKey="name" tick={{ ...TICK, fontSize: 10.5 }} />
                                    <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ ...TICK, fontSize: 9 }} axisLine={false} />
                                    <Tooltip content={<Tip fmt={pct} />} />
                                    <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                    <Radar name="Raised" dataKey="Raised" stroke={C_RAISED} fill={C_RAISED} fillOpacity={0.22} strokeWidth={2} {...ANIM} />
                                    <Radar name="Claimed" dataKey="Claimed" stroke={C_CLAIMED} fill={C_CLAIMED} fillOpacity={0.22} strokeWidth={2} {...ANIM} />
                                </RadarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : <div className="invd-empty">No utilization yet.</div>}
                </Panel>
            </div>

            {/* row 3 */}
            <Panel i={4} title="Top projects" note="Raised vs claimed · click a bar to filter by project">
                {topProjects.length ? (
                    <div className="invd-chart tall">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={topProjects} layout="vertical" margin={{ left: 8, right: 16, top: 4 }}>
                                <CartesianGrid horizontal={false} stroke="#EDF1F5" strokeDasharray="3 4" />
                                <XAxis type="number" tickFormatter={short} tick={TICK} axisLine={false} tickLine={false} />
                                <YAxis type="category" dataKey="name" tick={TICK} axisLine={false} tickLine={false} width={130} />
                                <Tooltip content={<Tip />} cursor={{ fill: "#F3F5F7" }} />
                                <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12, fontFamily: FONT }} />
                                <Bar dataKey="Raised" fill={C_RAISED} radius={[0, 6, 6, 0]} maxBarSize={14} cursor="pointer"
                                    onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM} />
                                <Bar dataKey="Claimed" fill={C_CLAIMED} radius={[0, 6, 6, 0]} maxBarSize={14} cursor="pointer"
                                    onClick={(d) => onPickProject(activeProject === d.id ? "" : d.id)} {...ANIM} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                ) : <div className="invd-empty">No project data yet.</div>}
            </Panel>

            {/* category table */}
            <Panel i={5} title={`${cat === "all" ? "All categories" : CATS[cat]}: raised vs claimed`}>
                <div className="invd-tw">
                    <table className="invd-table">
                        <thead>
                            <tr>
                                <th>Category</th><th className="r">Contract (EOT)</th>
                                <th className="r">Raised</th><th className="r">Claimed</th>
                                <th className="r">Unclaimed</th><th className="r">Raised remaining</th>
                                <th className="r">Claimed remaining</th>
                                {ded && <><th className="r">Deducted</th><th className="r">Released</th></>}
                                <th>Claimed %</th>
                            </tr>
                        </thead>
                        <tbody key={cat}>
                            {tableCats.map((c, i) => (
                                <tr key={c.key} style={{ "--i": i }}>
                                    <td><span className="invd-dot" style={{ background: COLOR[c.key] }} /><b>{c.name}</b></td>
                                    <td className="r">{inr(c.eot)}</td>
                                    <td className="r amt">{inr(c.rCum)}</td>
                                    <td className="r">{inr(c.cCum)}</td>
                                    <td className="r">{inr(c.gap)}</td>
                                    <td className="r">{inr(c.rRem)}</td>
                                    <td className="r">{inr(c.cRem)}</td>
                                    {ded && <><td className="r">{inr(c.dNet)}</td><td className="r">{inr(c.dRel)}</td></>}
                                    <td className="usedcell"><Meter pct={c.pct} color={COLOR[c.key]} /><small>{c.pct.toFixed(2)}%</small></td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.eot, 0))}</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.rCum, 0))}</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.cCum, 0))}</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.gap, 0))}</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.rRem, 0))}</td>
                                <td className="r">{inr(tableCats.reduce((a, c) => a + c.cRem, 0))}</td>
                                {ded && <><td className="r">{inr(tableCats.reduce((a, c) => a + c.dNet, 0))}</td><td className="r">{inr(tableCats.reduce((a, c) => a + c.dRel, 0))}</td></>}
                                <td />
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Panel>

            {/* projects table */}
            <Panel i={6} title="Projects" note={`${tableRows.length} of ${rows.length} shown`}>
                <div className="invd-toolbar">
                    <input className="invd-input" placeholder="Search project or location…" value={q} onChange={(e) => setQ(e.target.value)} />
                    <label className="invd-check">
                        <input type="checkbox" checked={showEmpty} onChange={(e) => setShowEmpty(e.target.checked)} />
                        Show projects with no invoices or claims
                    </label>
                    <button type="button" className="invd-btn" onClick={() => exportBothCsv(tableRows)}>Export CSV</button>
                </div>
                <div className="invd-tw">
                    <table className="invd-table">
                        <thead>
                            <tr>
                                <th>Project</th><th>Location</th>
                                <th className="r">Invoices</th><th className="r">Claims</th>
                                <th className="r">Raised</th><th className="r">Claimed</th>
                                <th className="r">Unclaimed</th><th>Claimed %</th>
                            </tr>
                        </thead>
                        <tbody key={`${showEmpty}|${q}`}>
                            {tableRows.map((r, i) => (
                                <tr key={r.id} style={{ "--i": Math.min(i, 20), cursor: "pointer" }}
                                    className={`${r.rCum || r.cCum ? "" : "dim"} ${activeProject === r.id ? "sel" : ""}`}
                                    onClick={() => onPickProject(activeProject === r.id ? "" : r.id)}>
                                    <td><b>{r.name}</b></td>
                                    <td>{r.location || "—"}</td>
                                    <td className="r">{r.rInv}</td>
                                    <td className="r">{r.cInv}</td>
                                    <td className="r amt">{inr(r.rCum)}</td>
                                    <td className="r">{inr(r.cCum)}</td>
                                    <td className="r">{inr(r.gap)}</td>
                                    <td className="usedcell"><Meter pct={r.pct} color={C_CLAIMED} /><small>{r.pct.toFixed(2)}%</small></td>
                                </tr>
                            ))}
                            {!tableRows.length && <tr><td colSpan={8}><div className="invd-empty">No projects to show.</div></td></tr>}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}

const Soon = ({ name }) => (
    <div className="invd-soon"><b>{name} is not connected yet</b><span>Add its endpoint in useInvoiceDashboard and render a view here.</span></div>
);

/* ───────── page ───────── */
export default function InvoiceDashboard({
    baseUrl = `${BASE_URL}/siteproject/invoicedashboard`,
    claimUrl = `${BASE_URL}/siteproject/invoiceclaimdashboard`,
    deductionUrl = `${BASE_URL}/siteproject/invoicedeductionfilter`,
    releaseUrl = `${BASE_URL}/siteproject/invoiceDeductionReleaseByProject`,
    http = axios,
}) {
    const [f, setF] = useState({ project: "", month: "", year: "" });
    const [stage, setStage] = useState("raised");
    const [opts, setOpts] = useState({ projects: [], months: [], years: [] });

    const isBoth = stage === "both";
    const raised = useInvoiceDashboard(http, baseUrl, f, stage === "raised" || isBoth);
    const claimed = useInvoiceDashboard(http, claimUrl, f, stage === "claimed" || isBoth);

    // month & year dono null ho tab hi deduction (net of release) current se minus hoga
    const noPeriod = !f.month && !f.year;
    const dedMap = useDeductions(http, deductionUrl, releaseUrl, f.project, noPeriod && (stage === "raised" || isBoth));
    const adj = useMemo(
        () => (noPeriod ? applyDeductions(raised.data, dedMap, isBoth) : { data: raised.data, ded: null }),
        [raised.data, dedMap, noPeriod, isBoth]
    );

    const single = stage === "claimed" ? claimed : { ...raised, data: adj.data };
    const ready = isBoth ? raised.data && claimed.data : single.data;
    const busy = isBoth ? raised.loading || claimed.loading : single.loading;
    const err = isBoth ? raised.error || claimed.error : single.error;
    const reload = () => {
        if (stage === "raised" || isBoth) raised.reload();
        if (stage === "claimed" || isBoth) claimed.reload();
    };

    // filter options hamesha raised data se aate hain
    useEffect(() => {
        const d = raised.data;
        if (!d || f.project || f.month || f.year) return;
        const ps = d.projects || [];
        const uniq = (k) => [...new Set(ps.flatMap((p) => p[k] || []))].sort();
        setOpts({ projects: ps.map((p) => ({ id: p.project_id, label: pLabel(p) })), months: uniq("months_available"), years: uniq("years_available") });
    }, [raised.data, f.project, f.month, f.year]);

    const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
    const stages = [
        ["raised", "Invoice raised"],
        ["claimed", "Claims"],
        ["both", "Raised + Claims"],
        ["payment", "Payments & deductions"],
    ];
    const showCP = !!(f.month || f.year);
    const errLabel = isBoth ? "raised + claim" : stage === "claimed" ? "claim" : "invoice";

    return (
        <div className="invd-root">
            <header className="invd-head">
                <div>
                    <h1 className="invd-title">Invoice dashboard</h1>
                    <p className="invd-sub">
                        {isBoth ? "Raised and claimed side by side, and what is still unclaimed." : "What has been raised, and what is left, across projects."}
                    </p>
                </div>
                <div className="invd-filters">
                    <Select value={f.project} onChange={set("project")}>
                        <option value="">All projects</option>
                        {opts.projects.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
                    </Select>
                    <Select value={f.month} onChange={set("month")}>
                        <option value="">All months</option>
                        {opts.months.map((m) => <option key={m} value={m}>{MONTHS[+m - 1] || m}</option>)}
                    </Select>
                    <Select value={f.year} onChange={set("year")}>
                        <option value="">All years</option>
                        {opts.years.map((y) => <option key={y} value={y}>{y}</option>)}
                    </Select>
                </div>
            </header>

            <nav className="invd-tabs" style={{ "--idx": stages.findIndex(([k]) => k === stage), "--n": stages.length }}>
                {stages.map(([k, label]) => (
                    <button key={k} onClick={() => setStage(k)} className={`invd-tab ${stage === k ? "on" : ""}`}>{label}</button>
                ))}
            </nav>

            {stage === "payment" ? (
                <div key={stage} className="invd-fade"><Soon name={stages.find(([k]) => k === stage)[1]} /></div>
            ) : err ? (
                <div className="invd-err">
                    <b>Could not load {errLabel} data</b>
                    <p>{err}</p>
                    <button onClick={reload}>Retry</button>
                </div>
            ) : !ready && busy ? (
                <Skeleton />
            ) : !ready ? (
                <Skeleton />
            ) : isBoth ? (
                <div key={`both|${f.project}|${f.month}|${f.year}`} className={`invd-fade ${busy ? "invd-dim" : ""}`}>
                    <CombinedView raised={adj.data} claimed={claimed.data} ded={adj.ded} activeProject={f.project}
                        onPickProject={set("project")} showCP={showCP} />
                </div>
            ) : (
                <div key={`${stage}|${f.project}|${f.month}|${f.year}`} className={`invd-fade ${busy ? "invd-dim" : ""}`}>
                    <RaisedView data={single.data} ded={stage === "raised" ? adj.ded : null} activeProject={f.project} onPickProject={set("project")}
                        T={stage === "claimed" ? TXT.claimed : TXT.raised} showCP={showCP} />
                </div>
            )}
        </div>
    );
}